// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { motion } from "framer-motion";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import Header from "../../components/common/Header";
// import { X } from "lucide-react";

// const Lightbox = ({ image, title, onClose }) => {
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, []);

//   return (
//     <div
//       className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
//       onClick={onClose}
//     >
//       <button
//         onClick={onClose}
//         className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
//       >
//         <X className="w-8 h-8" />
//       </button>
//       <div
//         className="max-w-7xl max-h-full"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <img
//           src={image}
//           alt={title}
//           className="max-w-full max-h-[90vh] object-contain mx-auto"
//         />
//         <p className="text-white text-center mt-4 text-lg">{title}</p>
//       </div>
//     </div>
//   );
// };

// const Gallery = () => {
//   const [galleryData, setGalleryData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedImage, setSelectedImage] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/campus-gallery/get-all`
//         );
//         setGalleryData(res.data);
//       } catch (error) {
//         console.error("Error fetching gallery data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <>
//       <Header
//         title="Gallery"
//         description="Explore our curated collection of stunning visuals capturing special moments and memories."
//         breadcrumbs={[
//           { label: "HOME", path: "/" },
//           { label: "GALLERY", path: "/gallery" },
//         ]}
//       />

//       <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h1 className="text-5xl font-extrabold text-gray-900 mb-4 heading">
//             Gallery
//           </h1>
//           <p className="text-lg text-gray-600 max-w-2xl mx-auto sub-heading">
//             Explore our curated collection of moments from our campus events,
//             programs, and celebrations.
//           </p>
//         </div>

//         {loading ? (
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
//             {Array(10)
//               .fill(0)
//               .map((_, i) => (
//                 <div key={i} className="bg-white shadow-md rounded-xl p-4">
//                   <Skeleton height={160} className="rounded-lg mb-4" />
//                   <Skeleton width="70%" height={20} />
//                 </div>
//               ))}
//           </div>
//         ) : (
//           <div className="space-y-12">
//             {galleryData.map((gallery, idx) => (
//               <div key={gallery._id || idx}>
//                 <h2 className="text-2xl font-bold text-gray-800 mb-6 border-l-4 border-primaryBtnColor pl-3">
//                   {gallery.name}
//                 </h2>

//                 <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
//                   {gallery.images.map((img) => (
//                     <motion.div
//                       key={img._id}
//                       className="relative overflow-hidden rounded-2xl shadow-lg group cursor-pointer"
//                       whileHover={{ scale: 1.03 }}
//                       transition={{ duration: 0.3, ease: "easeInOut" }}
//                       onClick={() => setSelectedImage(img)}
//                     >
//                       <img
//                         src={img.url}
//                         alt={gallery.name}
//                         className="w-full h-[220px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
//                       />
//                       <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
//                         <p className="text-white text-lg font-medium">
//                           {gallery.name}
//                         </p>
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {selectedImage && (
//         <Lightbox
//           image={selectedImage.url}
//           title={selectedImage.title}
//           onClose={() => setSelectedImage(null)}
//         />
//       )}
//     </>
//   );
// };

// export default Gallery;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../../components/common/Header";
import { X, Play } from "lucide-react";

const Lightbox = ({ media, title, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const isVideo =
    media.url.includes("/video/upload/") ||
    media.url.match(/\.(mp4|webm|mov)$/i);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
      >
        <X className="w-8 h-8" />
      </button>
      <div className="w-full max-h-full" onClick={(e) => e.stopPropagation()}>
        {isVideo ? (
          <video
            src={media.url}
            controls
            autoPlay
            className="max-w-full max-h-[90vh] mx-auto"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={media.url}
            alt={title}
            className="max-w-full max-h-[90vh] object-contain mx-auto"
          />
        )}
        {title && (
          <p className="text-white text-center mt-4 text-lg font-semibold">
            {title}
          </p>
        )}
      </div>
    </div>
  );
};

const Gallery = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedGalleryName, setSelectedGalleryName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/campus-gallery/get-all`
        );
        setGalleryData(res.data);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const isVideo = (url) => {
    return url.includes("/video/upload/") || url.match(/\.(mp4|webm|mov)$/i);
  };

  const handleMediaClick = (media, galleryName) => {
    setSelectedMedia(media);
    setSelectedGalleryName(galleryName);
  };

  return (
    <>
      <Header
        title="Gallery"
        description="Explore our curated collection of stunning visuals capturing special moments and memories."
        breadcrumbs={[
          { label: "HOME", path: "/" },
          { label: "GALLERY", path: "/gallery" },
        ]}
      />

      <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-4 heading">
            Gallery
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto sub-heading">
            Explore our curated collection of moments from our campus events,
            programs, and celebrations.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {Array(10)
              .fill(0)
              .map((_, i) => (
                <div key={i} className="bg-white shadow-md rounded-xl p-4">
                  <Skeleton height={160} className="rounded-lg mb-4" />
                  <Skeleton width="70%" height={20} />
                </div>
              ))}
          </div>
        ) : (
          <div className="space-y-12">
            {galleryData.map((gallery, idx) => (
              <div key={gallery._id || idx}>
                <h2 className="text-2xl font-bold text-gray-800 mb-6 border-l-4 border-primaryBtnColor pl-3">
                  {gallery.name}
                </h2>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                  {gallery.images.map((img) => {
                    const isVideoFile = isVideo(img.url);

                    return (
                      <motion.div
                        key={img._id}
                        className="relative overflow-hidden rounded-2xl shadow-lg group cursor-pointer bg-gray-100"
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        onClick={() => handleMediaClick(img, gallery.name)}
                      >
                        {isVideoFile ? (
                          <>
                            <video
                              src={img.url}
                              className="w-full h-[220px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                              muted
                              playsInline
                            />
                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                              <div className="bg-white bg-opacity-95 rounded-full p-3 transform transition-transform duration-300 group-hover:scale-110 shadow-2xl">
                                <Play
                                  className="w-8 h-8 text-red-700"
                                  fill="currentColor"
                                />
                              </div>
                            </div>
                            <div className="absolute top-2 right-2 bg-red-600 text-white px-2 py-1 rounded text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                              VIDEO
                            </div>
                          </>
                        ) : (
                          <>
                            <img
                              src={img.url}
                              alt={gallery.name}
                              className="w-full h-[220px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                            />
                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                              <p className="text-white text-lg font-medium">
                                {gallery.name}
                              </p>
                            </div>
                          </>
                        )}
                      </motion.div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedMedia && (
        <Lightbox
          media={selectedMedia}
          title={selectedGalleryName}
          onClose={() => {
            setSelectedMedia(null);
            setSelectedGalleryName("");
          }}
        />
      )}
    </>
  );
};

export default Gallery;
